import styled from 'styled-components';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const items = [
  {
    num: '01',
    title: 'Llegamos a todo México',
    text: 'Desde nuestras instalaciones surtimos pedidos a toda la República Mexicana con tiempos de entrega definidos y cumplimiento garantizado.',
    stat: '20+',
    statLabel: 'años de experiencia',
  },
  {
    num: '02',
    title: 'Suministro garantizado',
    text: 'Si nuestras tarimas no satisfacen tus necesidades, contamos con garantía de cambio sin costo adicional ni burocracia.',
    stat: '100%',
    statLabel: 'garantía de cambio',
  },
  {
    num: '03',
    title: 'Pedidos a la medida',
    text: 'Fabricamos tarimas con las dimensiones, espesores y tipo de madera que tu operación necesita. Desde un pedido pequeño hasta grandes volúmenes, nos adaptamos a ti.',
    stat: '100%',
    statLabel: 'personalizable',
  },
];

function BenefitRow({ num, title, text, stat, statLabel, index }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <Row
      ref={ref}
      as={motion.div}
      initial={{ opacity: 0, x: -30 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
    >
      <RowNum>{num}</RowNum>
      <RowDivider />
      <RowBody>
        <RowTitle>{title}</RowTitle>
        <RowText>{text}</RowText>
      </RowBody>
      <RowStat>
        <StatBig>{stat}</StatBig>
        <StatLabel>{statLabel}</StatLabel>
      </RowStat>
    </Row>
  );
}

export default function Benefits() {
  return (
    <Section>
      <Inner>
        <Tag>¿Por qué elegirnos?</Tag>
        <List>
          {items.map((it, i) => (
            <BenefitRow key={it.num} {...it} index={i} />
          ))}
        </List>
      </Inner>
    </Section>
  );
}

const Section = styled.section`
  background: transparent;
  padding: 6rem 2rem;
`;

const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Tag = styled.p`
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--blue);
  border-left: 3px solid var(--red);
  padding-left: 0.75rem;
  margin-bottom: 3rem;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 56px 1px 1fr auto;
  align-items: center;
  gap: 2.5rem;
  padding: 2.5rem 0;
  border-bottom: 1px solid var(--border);
  &:first-child { border-top: 1px solid var(--border); }

  @media (max-width: 700px) {
    grid-template-columns: 40px 1px 1fr;
    gap: 1.5rem;
  }
`;

const RowNum = styled.span`
  font-family: 'Bebas Neue', sans-serif;
  font-size: 2.2rem;
  color: var(--red);
  line-height: 1;
  text-shadow: var(--shadow-3d);
`;

const RowDivider = styled.div`
  width: 1px;
  height: 100%;
  min-height: 60px;
  background: var(--border);
`;

const RowBody = styled.div``;

const RowTitle = styled.h3`
  font-size: 1.2rem;
  color: var(--blue);
  margin-bottom: 0.5rem;
`;

const RowText = styled.p`
  font-size: 0.9rem;
  line-height: 1.7;
  color: var(--text-sub);
  max-width: 520px;
`;

const RowStat = styled.div`
  text-align: right;
  @media (max-width: 700px) { display: none; }
`;

const StatBig = styled.p`
  font-family: 'Bebas Neue', sans-serif;
  font-size: 2.4rem;
  color: var(--blue);
  line-height: 1;
  text-shadow: var(--shadow-3d);
`;

const StatLabel = styled.p`
  font-size: 0.7rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-sub);
  margin-top: 0.2rem;
`;
